import { Component, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";
import { CacheKey } from "../../../shared/constants/cachekey.constants";
import { UserInfo } from "../../../shared/interface/user-info.interface";
import { CacheService } from "../../../shared/services/cache.service";
import { CommonService } from "../../../shared/services/common.service";
import { CommonMessage } from "../../common/common-messages";
import { RowStatus } from "../../common/enumerations";
import { NotificationType } from "../../enums/notification-types.enum";
import { TicketTypeModel } from "../../interface/ticketingsystem/ticket-types-model";
import { DeleteModal } from "../../models/delete-modal";
import { CustomerService } from "../../services/customer.service";

@Component({
    selector: "ticketType",
    templateUrl: "../../templates/template1/views/configuration/ticketType.component.html",
    styleUrls: ["../../templates/template1/themes/default/css/configuration.less"]
})
export class CreateTicketType implements OnInit {
    ticketTypeForm: FormGroup;
    operatingCountries: any[];
    isSubmitted:boolean;
    userInfo: UserInfo;
    message:string;
    ticketTypeId:number;
    ticketTypeInfo:any;
    isUpdate:boolean = false;
    clearPopup:DeleteModal;
    
    constructor(private router: Router,
        private _formbuilder: FormBuilder,
        private _commonService: CommonService,
        private _cacheService: CacheService,
        private _customerservice: CustomerService,
        private activatedRoute: ActivatedRoute) {
            this.ticketTypeId  =  +activatedRoute.snapshot.params['ticketTypeId'];
    }
    ngOnInit(): void {
        this.buildForm();
        this.getOperatingCountries();
        this.userInfo = this._cacheService.get(CacheKey.UserInfo);
        if(this.ticketTypeId){
            this.getTicketTypeInfo();
            this.isUpdate= true;
        }
        this.clearPopup = new DeleteModal(this.resetForm.bind(this),
            this.doNotRemoveFormData.bind(this), this.doNotRemoveFormData.bind(this));
        this.clearPopup.viewActionButtons = true;
    }
    buildForm() {
        this.ticketTypeForm = this._formbuilder.group({
            operatingCountryId: ['', Validators.required],
            ticketType: ['', Validators.required]
        });
    }
    resetForm(){
        if(this.isUpdate){
            this.getTicketTypeInfo();
        }
        else{
            this.ticketTypeForm.reset();
            this.buildForm();
        }
    }
    getOperatingCountries() {
        this._customerservice.getAllBusinessEntities().subscribe((response: any) => {
            if (response) {
                
                this.operatingCountries = response;
            }
        });
    }
    onSubmit(isValid : boolean){
        this.isSubmitted = true;
        if(isValid){
            let ticketTypeValues = this.ticketTypeForm.getRawValue();
            let ticketTypeReq= new TicketTypeModel();
            ticketTypeReq.value = ticketTypeValues.ticketType.trim();
            ticketTypeReq.operatingCountry = ticketTypeValues.operatingCountryId;
            let country= this.operatingCountries.find(item => item.id === +ticketTypeValues.operatingCountryId);
            country ? ticketTypeReq.operatingCountryName = country.name : null;
            ticketTypeReq.rowStatus = RowStatus.Active;
            if(!this.isUpdate){
                ticketTypeReq.createdBy = this.userInfo.userId;
            }
            else{
                ticketTypeReq.id=this.ticketTypeId; 
                ticketTypeReq.updatedBy = this.userInfo.userId;
            }
            this.isUpdate ? this.updateTicketType(ticketTypeReq):this.createTicketType(ticketTypeReq);
        }
    }

    createTicketType(ticketTypeReq:TicketTypeModel){
        this._customerservice.createTicketType(ticketTypeReq).subscribe((response: any) => {
            if (response && response.validations.length === 0) {
                this.message = "Ticket Type created successfully.";
                this._commonService.createNotification("", this.message, NotificationType.SUCCESS);
                this.isSubmitted = false;
                this.buildForm();
                this.router.navigate(['/customerservice/configuration/search']);                    
            }
            else if(response && response.validations.length > 0){
                this.message = response.validations[0].message;
                this._commonService.createNotification("", this.message, NotificationType.ERROR);
            }
            else{
                this.message = "Ticket Type creation failed.";
                this._commonService.createNotification("", this.message, NotificationType.ERROR);
            }
        });
    }

    updateTicketType(ticketTypeReq:TicketTypeModel){

        this._customerservice.updateTicketType(ticketTypeReq).subscribe((response: any) => {
            if (response && response.validations.length === 0) {
                this.message = "Ticket Type updated successfully.";
                this._commonService.createNotification("", this.message, NotificationType.SUCCESS);
            }
            else if(response && response.validations.length > 0){
                this.message = response.validations[0].message;
                this._commonService.createNotification("", this.message, NotificationType.ERROR);
            }
            else{
                this.message = "Ticket Type creation failed.";
                this._commonService.createNotification("", this.message, NotificationType.ERROR);
            }
            this.router.navigate(['/customerservice/configuration/search']);
        });
    }
    getTicketTypeInfo(){
        this._customerservice.getTicketTypeInfo(this.ticketTypeId).subscribe((response: any) => {
            if (response) {
                this.ticketTypeInfo = response;
                this.ticketTypeForm.patchValue({
                    operatingCountryId: this.ticketTypeInfo.operatingCountry,
                    ticketType: this.ticketTypeInfo.value
                })
            }
        });
    }
    doNotRemoveFormData() {
        //data should not be removed...
    }
    clear(){
        this.clearPopup.toggle = true;
        this.clearPopup.message = CommonMessage.clearFormData;
    }

}


// WEBPACK FOOTER //
// ./src/app/customerservice/components/configuration/ticketType.component.ts